import React, { useEffect } from 'react'
import AuthenticationControllerService from './Service'
import SessionManagerService from '../session-manager/Service'
import { useNotification } from '../../helpers'
import { navigate } from '@reach/router'
import { Vault } from 'lib'

export interface IAuthenticationCallback {
  enterpriseId?: string
  submissionLinkCode?: string
}

const AuthenticationCallback: React.FC<IAuthenticationCallback> = ({ enterpriseId, submissionLinkCode }) => {
  const { emitError } = useNotification()

  useEffect(() => {
    const doNavigate = () => {
      if (enterpriseId && submissionLinkCode) {
        navigate(`/enterprise/${enterpriseId}/${submissionLinkCode}/management`)
      } else {
        navigate('/top-fives')
      }
    }

    async function processAuthorizationToken() {
      if (Vault.getAccessToken()) {
        doNavigate()
        return
      }

      if (window.location.search) {
        const urlParams = new URLSearchParams(window.location.search)

        const code = urlParams.get('code')

        const [status, error] = await AuthenticationControllerService.fetchAccessToken(code)

        if (error) {
          if (status !== 204) {
            emitError(error)
          }
          AuthenticationControllerService.fetchAuthorizationToken()
        } else {
          await SessionManagerService.whoAmI()
          doNavigate()
        }
      }
    }

    processAuthorizationToken()
  }, [emitError])

  return (
    <React.Fragment>
      <span>Please wait...</span>
    </React.Fragment>
  )
}

export default AuthenticationCallback
